var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.HasScale
      ? _c("div", { staticClass: "DirectRateVotesBrowserView" }, [
          _c("ul", { staticClass: "nav nav-tabs" }, [
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.VotesTabActive },
                  on: { click: _vm.ShowVotesTabCommand },
                },
                [_vm._v("Votes")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.SummaryTabActive },
                  on: { click: _vm.ShowSummaryTabCommand },
                },
                [_vm._v("Chart")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.CommentsTabActive },
                  on: { click: _vm.ShowCommentsTabCommand },
                },
                [_vm._v("Comments")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.VotesTabActive
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane pt-2",
                    class: { active: _vm.VotesTabActive },
                  },
                  [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c("table", { staticClass: "table table-striped" }, [
                        _c(
                          "tbody",
                          [
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "\n                                        Average (" +
                                          _vm._s(
                                            _vm.Average != null
                                              ? _vm.Average.toFixedIfNeeded(2)
                                              : "N/A"
                                          ) +
                                          ")\n                                    "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.AverageCells, function (c) {
                                  return _c(
                                    "td",
                                    {
                                      class: {
                                        "bg-color-gray": c.Highlighted,
                                        "td-1": c.Colspan === 1,
                                        "td-2": c.Colspan > 1,
                                      },
                                      attrs: { colspan: c.Colspan },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "fg-color-white": c.Highlighted,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(c.Value.toFixedIfNeeded(2))
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.Entries, function (e) {
                              return _c(
                                "tr",
                                {
                                  key: e.ProjectUserId,
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(e.ProjectUserName ?? "???") +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.QuestionScale, function (lvl) {
                                    return _c(
                                      "td",
                                      {
                                        class: {
                                          "bg-color-green": lvl === e.Value,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "fg-color-white": lvl === e.Value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(lvl) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.SummaryTabActive
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane pt-2",
                    class: { active: _vm.SummaryTabActive },
                  },
                  [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c("table", { staticClass: "table" }, [
                        _c("tbody", [
                          _c(
                            "tr",
                            {
                              staticClass: "bottom noborder",
                              staticStyle: { "text-align": "center" },
                            },
                            _vm._l(_vm.HistogramValues, function (hv) {
                              return _c(
                                "td",
                                {
                                  staticStyle: {
                                    height: "400px",
                                    border: "none",
                                    "padding-top": "20px",
                                  },
                                },
                                [
                                  hv.Count
                                    ? _c("div", [_vm._v(_vm._s(hv.Count))])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "bg-color-green2",
                                    style: { height: hv.PercentOfMax + "%" },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            { staticStyle: { "text-align": "center" } },
                            _vm._l(_vm.QuestionScale, function (v) {
                              return _c(
                                "td",
                                { staticStyle: { width: "5%" } },
                                [_vm._v(_vm._s(v.toFixedIfNeeded(2)))]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.CommentsTabActive
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane pt-2",
                    class: { active: _vm.CommentsTabActive },
                  },
                  _vm._l(_vm.Comments, function (c) {
                    return _c("blockquote", { staticClass: "blockquote" }, [
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(c.Comment)),
                      ]),
                      _vm._v(" "),
                      _c("footer", { staticClass: "blockquote-footer" }, [
                        _vm._v(_vm._s(c.ProjectUserName ?? "???")),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.HasScale
      ? _c("div", { staticClass: "DirectValueVotesBrowserView" }, [
          _c("ul", { staticClass: "nav nav-tabs" }, [
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.VotesTabActive },
                  on: { click: _vm.ShowVotesTabCommand },
                },
                [_vm._v("Votes")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.CommentsTabActive },
                  on: { click: _vm.ShowCommentsTabCommand },
                },
                [_vm._v("Comments")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.VotesTabActive
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane pt-2",
                    class: { active: _vm.VotesTabActive },
                  },
                  [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c("table", { staticClass: "table table-striped" }, [
                        _c(
                          "tbody",
                          [
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c("td", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.Average != null
                                          ? _vm.Average.toFixedIfNeeded(2)
                                          : "N/A"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.VotesEntries, function (e) {
                              return _c(
                                "tr",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(e.ProjectUserName ?? "???") +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(e.Value) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.CommentsTabActive
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane pt-2",
                    class: { active: _vm.CommentsTabActive },
                  },
                  _vm._l(_vm.Comments, function (c) {
                    return _c("blockquote", { staticClass: "blockquote" }, [
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(c.Comment)),
                      ]),
                      _vm._v(" "),
                      _c("footer", { staticClass: "blockquote-footer" }, [
                        _vm._v(_vm._s(c.ProjectUserName ?? "???")),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticStyle: { "text-align": "left" } }, [
      _c("strong", [_c("span", [_vm._v("Average")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }